module.exports = __webpack_public_path__ + "img/shop_iron.fc6196de.jpg";